import React from "react";
var __jsx = React.createElement;
import { Icon } from "@syarahtech/ui";
// Number-of-cars stepper: supports +/- and manual typing, clamps to [min, max].
var NumberStepper = function NumberStepper(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? 1 : _ref$min,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 9999 : _ref$max,
    error = _ref.error,
    id = _ref.id;
  var clamp = function clamp(n) {
    return Math.min(max, Math.max(min, n));
  };
  var handleType = function handleType(raw) {
    var normalized = raw.replace(/[٠-٩]/g, function (d) {
      return String(d.charCodeAt(0) - 1632);
    });
    var digits = normalized.replace(/[^0-9]/g, "");
    if (digits === "") {
      onChange(NaN); // empty -> let validation flag required
      return;
    }
    onChange(clamp(parseInt(digits, 10)));
  };
  var current = Number.isNaN(value) ? "" : String(value);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between h-10 rounded-lg border border-solid bg-white overflow-hidden ".concat(error ? "border-[#E4002B]" : "border-[#E6E9EF]")
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    "aria-label": "decrease",
    className: "flex items-center justify-center w-11 h-full bg-[#F1F6FC] border-none cursor-pointer text-primary-new disabled:opacity-40",
    disabled: !Number.isNaN(value) && value <= min,
    onClick: function onClick() {
      return onChange(clamp((Number.isNaN(value) ? min : value) - 1));
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--remove",
    className: "text-[#0D0DB5]",
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("input", {
    id: id,
    type: "text",
    inputMode: "numeric",
    pattern: "[0-9]*",
    className: "flex-1 h-full text-center border-none outline-none bg-transparent text-base text-[#1B2035]",
    value: current,
    onChange: function onChange(e) {
      return handleType(e.target.value);
    }
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    "aria-label": "increase",
    className: "flex items-center justify-center w-11 h-full bg-[#F1F6FC] border-none cursor-pointer text-primary-new",
    onClick: function onClick() {
      return onChange(clamp((Number.isNaN(value) ? min - 1 : value) + 1));
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--add",
    className: "text-[#0D0DB5]",
    width: 4,
    height: 4
  }))), error && /*#__PURE__*/React.createElement("span", {
    className: "block mt-1 text-xs text-[#E4002B]"
  }, error));
};
export default NumberStepper;